import moment from 'moment';

export const monthsOptionsFunction = (locale = 'it') => {
  const MONTHS = [];
  moment.locale(locale);
  const dateStart = moment();

  const dateEnd = moment().add(12, 'month');
  // return [value: '2023-01', label: 'Gennaio']
  while (dateEnd.diff(dateStart, 'months') >= 0) {
    MONTHS.push({
      value: dateStart.format('YYYY-MM'),
      label: dateStart.format('MMMM'),
    });
    dateStart.add(1, 'month');
  }

  // return [1, 'Gennaio']
  const momentListMonths = moment.months();
  const MONTHSOPTIONS = momentListMonths.map((month, index) => {
    return [index + 1, month];
  });

  // return [1, 1]
  const DAYLIST = (monthSelected) => {
    const currentDate = moment();
    const monthSelectedString = monthSelected ? monthSelected.toString() : '1';

    const createDateFromMonth = moment([
      currentDate.get('year'),
      monthSelected - 1,
      1,
    ]);

    var daysInMonth = moment(monthSelectedString, 'MM').daysInMonth();
    // if the month has already passed, take the days of next year
    if (moment(currentDate).isAfter(createDateFromMonth)) {
      createDateFromMonth.add(1, 'year');
      daysInMonth = moment(createDateFromMonth, 'MM').daysInMonth();
    }

    var arrDays = [];
    for (let i = 1; i <= daysInMonth; i++) {
      arrDays.push([i, i]);
    }
    return arrDays;
  };

  return { MONTHS, MONTHSOPTIONS, DAYLIST };
};
